
    import Vue from 'vue';
    import CUPEService from '@/apps/shared/services/cupe-service';
    import MailService from '@/apps/shared/services/email-service';
    import CRMCotizadorWebService from '@/apps/shared/services/crm-service';
    import webSaleHelper from '@/apps/shared/utils/webSaleHelper';
    import ParamCotizService from '@/apps/shared/services/ParamCotizOfSession-service';
    import { TitleAndPromotionsDetails } from '@/apps/shared/models/titleAndPromotionsDetails';
    import ContractFinish from "@/apps/shared/components/ContractFinish.vue";

    interface payload {
        productId: number;
        pricingId: number;
        leadId: string;
        contratante: {
            firstName: string;
            lastName: string;
            documentNumber: string;
            areaCode: string;
            telephone: string;
            email: string;
        };
        plan: {
            planDescription: string;
            premioMensual: number;
            premioMensualFormatted: string;
            pricingId: number;
        };
        hogar: {
            articleCode: {
                description: string
            };
            selectedLocality: {
                name: string;
                zipCode: number
            };
        };
        buildingCapitalSelected: {
            amount: number
        };
        SecuritySystem: any;
        referente: string;
        medium: string;
    }

    interface getParamCotizResponse {
        hasData: boolean;
        message: string;
        data: string | null;
    }

    export default Vue.extend({
        components: {
            ContractFinish
        },
        name: 'FamilyHogarPremiumFinalPayment',
        data() {
            return {
                titleAndPromotionDetails: {
                    icon: {
                        src: '/icons/check.png',
                    },
                } as TitleAndPromotionsDetails,
                payload: null as payload | null,
            }
        },
        methods: {
            async pageCustomization() {
                const defaultTitle = 'Hogar Premium';
                var actualPath = '/hogar-premium';
                const rutaAlternativa = sessionStorage.getItem("rutaAlternativa");
                if (rutaAlternativa) {
                    actualPath = '/hogar-premium/elegiplan';
                }
                // Llamamos al helper que se encarga de toda la lógica
                try {
                    await webSaleHelper.pageCustomization(this.$route, this.Bus, this.$store, defaultTitle, actualPath, null, null);
                }
                catch (error) {
                    const statusCode = error.response.status;
                    this.Bus.$emit(
                        'show-service-fail',
                        statusCode,
                        [() => this.pageCustomization()]);
                }
            },

            updateByProductGoogleAnalytics() {
                window.globalThis.dataLayer = window.globalThis.dataLayer || [];
                const productGtmName = 'DefaultFamilyCombinedGTMInfo';
                this.Bus.$emit('updateByProductGoogleAnalytics', productGtmName);
            },

            getFilePath() {
                const rutaAlternativa = sessionStorage.getItem("rutaAlternativa");
                if (rutaAlternativa) {
                    this.$router.push(rutaAlternativa);
                }
                else { 
                    if (this.payload.rutaAlternativa) {
                        this.$router.push(this.payload.rutaAlternativa);
                    }
                    else {
                        this.$router.push({ name: 'tabOneFamilyCombinedPremium' });
                    }
                }
            },

            fetchSessionPayload(guid: string): Promise<void> {
                return ParamCotizService.getParamCotiz(guid)
                    .then(resp => {
                        if (!resp.hasData || !resp.data) {
                            console.warn(resp.message);
                            throw new Error(resp.message);
                        }
                        this.payload = JSON.parse(resp.data) as payload;
                    });
            },

            getMailValues() {
                const p = this.payload;

                const rawName = p.contratante.firstName.toLowerCase().split(' ')[0];
                const firstName = rawName.charAt(0).toUpperCase() + rawName.slice(1);

                const effectDate = new Date();
                const vigencyDate = new Date(effectDate);
                vigencyDate.setFullYear(effectDate.getFullYear() + 1);

                const parameters = [
                    { name: "@ReportCode", value: "28" },
                    { name: "@contratante", value: firstName },
                    { name: "@nombrePlan", value: p.plan.planDescription },
                    {
                        name: "@vigenciaDesde",
                        value: `${effectDate.getDate()}/${effectDate.getMonth() + 1}/${effectDate.getFullYear()}`
                    },
                    {
                        name: "@vigenciaHasta",
                        value: `${vigencyDate.getDate()}/${vigencyDate.getMonth() + 1}/${vigencyDate.getFullYear()}`
                    },
                    { name: "@costoMensual", value: p.plan.premioMensualFormatted },
                    { name: "@HogarType", value: p.hogar.articleCode.description.trim() },
                    {
                        name: "@SumaAsegurada",
                        value: `$${p.buildingCapitalSelected.amount.toLocaleString('de-DE', {
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 0,
                        })}`
                    },
                ];

                return JSON.stringify({
                    parameters,
                    to: p.contratante.email,
                    from: "cotizador@sancorseguros.com",
                    productId: 927
                });
            },

            async addFinishQuotation() {
                sessionStorage.setItem("ExitOrContinueModal", "true");
                NF.UI.Page.block();
                const p = this.payload;
                this.leadId = p.leadId;
                this.externalIdentifier = p.pricingId.toString();

                const premioNum = Number.isInteger(p.plan.premioMensual)
                    ? p.plan.premioMensual
                    : parseInt(p.plan.premioMensual.toString().replace(/\./g, ''), 10);

                window.globalThis.dataLayer = window.globalThis.dataLayer || [];
                window.globalThis.dataLayer.push({
                    pas: null,
                    email: this.payload.contratante.email,
                    product: 'hogarPremium',
                    event: 'cotizador-hogar-premium-venta-completa',
                    value: premioNum,
                    referente: this.payload.referente,
                    medio: this.payload.medium
                });

                const finishResult = await CUPEService.Finish(
                    parseInt(this.externalIdentifier, 10),
                    p.productId,
                    p.contratante.lastName,
                    p.contratante.documentNumber,
                    `${p.hogar.selectedLocality.name} ${p.hogar.selectedLocality.zipCode}`,
                    p.contratante.email,
                    p.contratante.firstName,
                    p.plan.pricingId.toString(),
                    premioNum,
                    p.plan.planDescription,
                    "Hogar Premium",
                    p.contratante.areaCode,
                    p.contratante.telephone
                );

                if (finishResult) {
                    // CRM
                    CRMCotizadorWebService.CreateOrEditLead(
                        this.leadId!, null, location.href, null,
                        null, p.productId, true, "7", null, null, null
                    );

                    //ENVIO DE EMAIL
                    await MailService.sendMail(this.getMailValues()).then(response => {
                        let notificationType = response.result ? NF.Notification.Type.SUCCESS : NF.Notification.Type.ERROR;
                        let notificationTitle = response.result ? 'Mail Enviado' : 'Error';
                        let notificationContent = response.result ? 'Mail enviado exitosamente.' : 'Se produjo un error inesperado.';
                        NF.Notification.show({
                            type: notificationType,
                            title: notificationTitle,
                            content: notificationContent,
                            position: NF.Notification.Positions.TOP_RIGHT,
                            clickClose: true,
                            autoHideDelay: 10000,
                        });
                    }).finally(() => NF.UI.Page.unblock());

                } else {
                    // error servidor
                    window.globalThis.dataLayer.push({
                        pas: null,
                        email: this.payload.contratante.email,
                        product: 'hogarPremium',
                        event: 'errorServidor',
                        paso: 'cotizador-hogar-premium-venta-completa',
                        referente: this.payload.referente,
                        medio: this.payload.medium
                    });
                }
            },
        },
        async mounted() {
            try {
                NF.UI.Page.block();

                const guid = sessionStorage.getItem('ParamId');
                if (!guid) {
                    console.error('No hay ParamId en sessionStorage');
                    return;
                }

                const parallelPromises = [
                    this.pageCustomization(),
                    this.updateByProductGoogleAnalytics(),
                    this.fetchSessionPayload(guid)
                ];

                await Promise.all([
                    ...parallelPromises,
                ]);

                await this.addFinishQuotation();

            } finally {
                NF.UI.Page.unblock();
            }
        },
    });
